import { forwardRef, type SVGProps } from 'react';

export const EditIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function EditIcon(props, ref) {
    return (
      <svg
        ref={ref}
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.3 8.925L15.05 4.725L16.45 3.325C16.8333 2.94167 17.3043 2.75 17.863 2.75C18.421 2.75 18.8917 2.94167 19.275 3.325L20.675 4.725C21.0583 5.10833 21.2583 5.571 21.275 6.113C21.2917 6.65433 21.1083 7.11667 20.725 7.5L19.3 8.925ZM17.85 10.4L7.25 21H3V16.75L13.6 6.15L17.85 10.4Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
